/**
 * Provides all tokens of a specific theme edited by design team.
 * This file is automatically generated from /scripts/figma-synchronise-tokens.sh.
 * PLEASE DO NOT EDIT HERE
 */
const lightTheme = {
  colors: {
    danger: {
      background: '#ffe1e7',
      backgroundDisabled: '#fff5f7',
      backgroundHover: '#ffe1e7',
      backgroundStrong: '#dd3252',
      backgroundStrongDisabled: '#fbbac6',
      backgroundStrongHover: '#a6102d',
      backgroundWeak: '#ffffff',
      backgroundWeakDisabled: '#fff5f7',
      backgroundWeakHover: '#ffe1e7',
      border: '#a6102d',
      borderDisabled: '#fbbac6',
      borderHover: '#a6102d',
      borderStrong: '#ffffff',
      borderStrongDisabled: '#fbbac6',
      borderStrongHover: '#a6102d',
      borderWeak: '#dd3252',
      borderWeakDisabled: '#fbbac6',
      borderWeakHover: '#a6102d',
      icon: '#a6102d',
      iconDisabled: '#fbbac6',
      iconHover: '#a6102d',
      iconStrong: '#ffffff',
      iconStrongDisabled: '#fff5f7',
      iconStrongHover: '#ffffff',
      iconWeak: '#dd3252',
      iconWeakDisabled: '#fbbac6',
      iconWeakHover: '#a6102d',
      text: '#a6102d',
      textDisabled: '#fbbac6',
      textHover: '#a6102d',
      textStrong: '#ffffff',
      textStrongDisabled: '#fff5f7',
      textStrongHover: '#ffffff',
      textWeak: '#dd3252',
      textWeakDisabled: '#fbbac6',
      textWeakHover: '#a6102d'
    },
    info: {
      background: '#e1ebff',
      backgroundDisabled: '#f4f7ff',
      backgroundHover: '#c4d5f8',
      backgroundStrong: '#3f6ed8',
      backgroundStrongDisabled: '#a8bff1',
      backgroundStrongHover: '#1a4dbf',
      backgroundWeak: '#ffffff',
      backgroundWeakDisabled: '#f4f7ff',
      backgroundWeakHover: '#e1ebff',
      border: '#1a4dbf',
      borderDisabled: '#a8bff1',
      borderHover: '#1a4dbf',
      borderStrong: '#ffffff',
      borderStrongDisabled: '#a8bff1',
      borderStrongHover: '#1a4dbf',
      borderWeak: '#3f6ed8',
      borderWeakDisabled: '#a8bff1',
      borderWeakHover: '#1a4dbf',
      icon: '#1a4dbf',
      iconDisabled: '#a8bff1',
      iconHover: '#1a4dbf',
      iconStrong: '#ffffff',
      iconStrongDisabled: '#f4f7ff',
      iconStrongHover: '#ffffff',
      iconWeak: '#3f6ed8',
      iconWeakDisabled: '#a8bff1',
      iconWeakHover: '#1a4dbf',
      text: '#1a4dbf',
      textDisabled: '#a8bff1',
      textHover: '#1a4dbf',
      textStrong: '#ffffff',
      textStrongDisabled: '#f4f7ff',
      textStrongHover: '#ffffff',
      textWeak: '#3f6ed8',
      textWeakDisabled: '#a8bff1',
      textWeakHover: '#1a4dbf'
    },
    neutral: {
      background: '#ffffff',
      backgroundDisabled: '#f6f6f8',
      backgroundHover: '#fcfcfd',
      backgroundStrong: '#f6f6f8',
      backgroundStrongDisabled: '#f6f6f8',
      backgroundStrongHover: '#d4dae7',
      backgroundStronger: '#4a4f62',
      backgroundStrongerDisabled: '#f6f6f8',
      backgroundWeak: '#ffffff',
      backgroundWeakDisabled: '#f6f6f8',
      backgroundWeakElevated: '#ffffff',
      backgroundWeakHover: '#e6e9f0',
      border: '#e6e9f0',
      borderDisabled: '#d4dae7',
      borderHover: '#e6e9f0',
      borderStrong: '#d4dae7',
      borderStrongDisabled: '#d4dae7',
      borderStrongHover: '#d4dae7',
      borderStronger: '#ffffff',
      borderStrongerDisabled: '#d4dae7',
      borderWeak: '#d4dae7',
      borderWeakDisabled: '#d4dae7',
      borderWeakHover: '#d4dae7',
      icon: '#4a4f62',
      iconDisabled: '#c4c9d6',
      iconHover: '#4a4f62',
      iconStrong: '#151a2d',
      iconStrongDisabled: '#c4c9d6',
      iconStrongHover: '#151a2d',
      iconStronger: '#ffffff',
      iconStrongerDisabled: '#c4c9d6',
      iconWeak: '#b2b6c3',
      iconWeakDisabled: '#c4c9d6',
      iconWeakHover: '#4a4f62',
      text: '#4a4f62',
      textDisabled: '#c4c9d6',
      textHover: '#4a4f62',
      textStrong: '#151a2d',
      textStrongDisabled: '#c4c9d6',
      textStrongHover: '#151a2d',
      textStronger: '#ffffff',
      textStrongerDisabled: '#c4c9d6',
      textWeak: '#b2b6c3',
      textWeakDisabled: '#c4c9d6',
      textWeakHover: '#4a4f62'
    },
    other: {
      data: {
        charts: {
          danger: '#ce2f4c',
          data1: '#5e47be',
          data10: '#96edf2',
          data11: '#002e50',
          data12: '#2c8564',
          data13: '#e3a3ff',
          data14: '#bada53',
          data2: '#0083e6',
          data3: '#3ebd8f',
          data4: '#ac2740',
          data5: '#9a85ec',
          data6: '#ff602e',
          data7: '#483800',
          data8: '#02a5ad',
          data9: '#ffa488',
          success: '#45d19f'
        }
      },
      gradients: {
        background: {
          aqua: 'linear-gradient(199.45deg, #03d5e0 14.03%, #4f0599 88.52%)',
          blue: 'linear-gradient(200.14deg, #0092ff 13.73%, #4f0599 86.59%)',
          fuschia: 'linear-gradient(200.02deg, #ff1c6e 13.34%, #4f0599 86.64%)',
          green: 'linear-gradient(202.33deg, #45d29f 15.16%, #4f0599 85.44%)',
          orange: 'linear-gradient(201.62deg, #ff5d2a 14.62%, #4f0599 85.81%)',
          pink: 'linear-gradient(200.94deg, #ff0cd2 14.71%, #4f0599 86.16%)',
          primary: 'linear-gradient(0deg, #151a2d 0%, #4f0599 100%)',
          purple: 'linear-gradient(197.81deg, #8430d9 12.89%, #4f0599 87.84%)'
        }
      },
      icon: {
        category: {
          primary: {
            fill: '#4f0599',
            fillStrong: '#a365f6'
          }
        },
        product: {
          danger: {
            fill: '#ffe1e7',
            fillDisabled: '#d4dae7',
            fillStrong: '#ffe1e7',
            fillStrongDisabled: '#d4dae7',
            fillWeak: '#dd3252',
            fillWeakDisabled: '#f6f6f8'
          },
          primary: {
            fill: '#4f0599',
            fillDisabled: '#d4dae7',
            fillStrong: '#a365f6',
            fillStrongDisabled: '#d4dae7',
            fillWeak: '#eeeeff',
            fillWeakDisabled: '#f6f6f8'
          },
          warning: {
            fill: '#ffe3d6',
            fillDisabled: '#d4dae7',
            fillStrong: '#ffefe6',
            fillStrongDisabled: '#d4dae7',
            fillWeak: '#ff8c69',
            fillWeakDisabled: '#f6f6f8'
          }
        }
      }
    },
    overlay: '#4A4F62A6',
    primary: {
      background: '#eeeeff',
      backgroundDisabled: '#f9f9ff',
      backgroundHover: '#d7ccf0',
      backgroundStrong: '#4f0599',
      backgroundStrongDisabled: '#bda5df',
      backgroundStrongHover: '#390171',
      backgroundWeak: '#ffffff',
      backgroundWeakDisabled: '#f9f9ff',
      backgroundWeakHover: '#eeeeff',
      border: '#390171',
      borderDisabled: '#bda5df',
      borderHover: '#390171',
      borderStrong: '#ffffff',
      borderStrongDisabled: '#bda5df',
      borderStrongHover: '#390171',
      borderWeak: '#4f0599',
      borderWeakDisabled: '#bda5df',
      borderWeakHover: '#4f0599',
      icon: '#390171',
      iconDisabled: '#bda5df',
      iconHover: '#390171',
      iconStrong: '#ffffff',
      iconStrongDisabled: '#f9f9ff',
      iconStrongHover: '#ffffff',
      iconWeak: '#4f0599',
      iconWeakDisabled: '#bda5df',
      iconWeakHover: '#4f0599',
      text: '#390171',
      textDisabled: '#bda5df',
      textHover: '#390171',
      textStrong: '#ffffff',
      textStrongDisabled: '#f9f9ff',
      textStrongHover: '#ffffff',
      textWeak: '#4f0599',
      textWeakDisabled: '#bda5df',
      textWeakHover: '#4f0599'
    },
    secondary: {
      backgroundStrong: '#a365f6'
    },
    success: {
      background: '#eafffb',
      backgroundDisabled: '#f5fff6',
      backgroundHover: '#cdfcf1',
      backgroundStrong: '#22c8a2',
      backgroundStrongDisabled: '#9fefdd',
      backgroundStrongHover: '#149a7b',
      backgroundWeak: '#ffffff',
      backgroundWeakDisabled: '#f5fff6',
      backgroundWeakHover: '#eafffb',
      border: '#149a7b',
      borderDisabled: '#9fefdd',
      borderHover: '#149a7b',
      borderStrong: '#ffffff',
      borderStrongDisabled: '#9fefdd',
      borderStrongHover: '#149a7b',
      borderWeak: '#22c8a2',
      borderWeakDisabled: '#9fefdd',
      borderWeakHover: '#149a7b',
      icon: '#149a7b',
      iconDisabled: '#9fefdd',
      iconHover: '#149a7b',
      iconStrong: '#ffffff',
      iconStrongDisabled: '#f5fff6',
      iconStrongHover: '#ffffff',
      iconWeak: '#22c8a2',
      iconWeakDisabled: '#9fefdd',
      iconWeakHover: '#149a7b',
      text: '#149a7b',
      textDisabled: '#9fefdd',
      textHover: '#149a7b',
      textStrong: '#ffffff',
      textStrongDisabled: '#f5fff6',
      textStrongHover: '#ffffff',
      textWeak: '#22c8a2',
      textWeakDisabled: '#9fefdd',
      textWeakHover: '#149a7b'
    },
    warning: {
      background: '#ffefe6',
      backgroundDisabled: '#fffcfa',
      backgroundHover: '#ffe3d6',
      backgroundStrong: '#ff8c69',
      backgroundStrongDisabled: '#ffd7c1',
      backgroundStrongHover: '#cc4e18',
      backgroundWeak: '#ffffff',
      backgroundWeakDisabled: '#fffcfa',
      backgroundWeakHover: '#ffefe6',
      border: '#cc4e18',
      borderDisabled: '#ffc8a9',
      borderHover: '#cc4e18',
      borderStrong: '#ffffff',
      borderStrongDisabled: '#ffd7c1',
      borderStrongHover: '#cc4e18',
      borderWeak: '#ff8c69',
      borderWeakDisabled: '#ffc8a9',
      borderWeakHover: '#cc4e18',
      icon: '#cc4e18',
      iconDisabled: '#ffc8a9',
      iconHover: '#cc4e18',
      iconStrong: '#ffffff',
      iconStrongDisabled: '#fffcfa',
      iconStrongHover: '#ffffff',
      iconWeak: '#ff8c69',
      iconWeakDisabled: '#ffc8a9',
      iconWeakHover: '#cc4e18',
      text: '#cc4e18',
      textDisabled: '#ffc8a9',
      textHover: '#cc4e18',
      textStrong: '#ffffff',
      textStrongDisabled: '#fffcfa',
      textStrongHover: '#ffffff',
      textWeak: '#ff8c69',
      textWeakDisabled: '#ffc8a9',
      textWeakHover: '#cc4e18'
    }
  },
  radii: {
    circle: '100%',
    default: '4px',
    large: '8px',
    none: '0',
    small: '2px',
    xlarge: '16px'
  },
  shadows: {
    bulk: '0px 4px 32px 8px #D4DAE766',
    defaultShadow: '0px 0px 8px 2px #D4DAE766',
    drawer: '0px 0px 40px 10px #151A2D5C',
    dropdown: '0px 4px 24px 6px #D4DAE766',
    focusDanger: '0px 0px 0px 3px #DD325240',
    focusInfo: '0px 0px 0px 3px rgba(63,110,216,0.25)',
    focusNeutral: '0px 0px 0px 3px #151A2D5C',
    focusPrimary: '0px 0px 0px 3px #4F059940',
    focusSuccess: '0px 0px 0px 3px rgba(34,200,162,0.25)',
    focusWarning: '0px 0px 0px 3px #FF8C6940',
    hoverDanger: '0px 4px 16px 4px #FFE1E7CC',
    hoverPrimary: '0px 4px 16px 4px #EEEEFFCC',
    hoverWarning: '0px 4px 16px 4px #FFEFE6CC',
    menu: '0px 0px 24px 6px #D4DAE766',
    modal: '0px 8px 40px 10px #151A2D5C',
    popover: '0px 4px 32px 8px #151A2D5C',
    tooltip: '0px 4px 32px 8px #D4DAE766'
  },
  space: {
    '0': '0',
    '0.25': '2px',
    '0.5': '4px',
    '1': '8px',
    '1.5': '12px',
    '10': '80px',
    '2': '16px',
    '3': '24px',
    '4': '32px',
    '5': '40px',
    '6': '48px',
    '7': '56px',
    '8': '64px',
    '9': '72px'
  },
  theme: 'light',
  typography: {
    body: {
      fontFamily: 'Asap',
      fontSize: '16px',
      fontWeight: 'Regular',
      letterSpacing: '0',
      lineHeight: '24px',
      paragraphSpacing: 'none',
      textCase: 'none',
      textDecoration: 'none',
      weight: '400'
    },
    bodySmall: {
      fontFamily: 'Asap',
      fontSize: '14px',
      fontWeight: 'Regular',
      letterSpacing: '0',
      lineHeight: '20px',
      paragraphSpacing: '0',
      textCase: 'none',
      textDecoration: 'none',
      weight: '400'
    },
    bodySmallStrong: {
      fontFamily: 'Asap',
      fontSize: '14px',
      fontWeight: 'Medium',
      letterSpacing: '0',
      lineHeight: '20px',
      paragraphSpacing: '0',
      textCase: 'none',
      textDecoration: 'none',
      weight: '500'
    },
    bodySmallStronger: {
      fontFamily: 'Asap',
      fontSize: '14px',
      fontWeight: 'SemiBold',
      letterSpacing: '0',
      lineHeight: '20px',
      paragraphSpacing: '0',
      textCase: 'none',
      textDecoration: 'none',
      weight: '600'
    },
    bodyStrong: {
      fontFamily: 'Asap',
      fontSize: '16px',
      fontWeight: 'Medium',
      letterSpacing: '0',
      lineHeight: '24px',
      paragraphSpacing: '0',
      textCase: 'none',
      textDecoration: 'none',
      weight: '500'
    },
    bodyStronger: {
      fontFamily: 'Asap',
      fontSize: '16px',
      fontWeight: 'SemiBold',
      letterSpacing: '0',
      lineHeight: '24px',
      paragraphSpacing: '0',
      textCase: 'none',
      textDecoration: 'none',
      weight: '600'
    },
    caption: {
      fontFamily: 'Asap',
      fontSize: '12px',
      fontWeight: 'Medium',
      letterSpacing: '0',
      lineHeight: '16px',
      paragraphSpacing: '0',
      textCase: 'none',
      textDecoration: 'none',
      weight: '500'
    },
    captionSmall: {
      fontFamily: 'Asap',
      fontSize: '10px',
      fontWeight: 'Medium',
      letterSpacing: '0',
      lineHeight: '16px',
      paragraphSpacing: '0',
      textCase: 'none',
      textDecoration: 'none',
      weight: '500'
    },
    code: {
      fontFamily: 'JetBrains',
      fontSize: '14px',
      fontWeight: 'Regular',
      letterSpacing: '0',
      lineHeight: '20px',
      paragraphSpacing: '0',
      textCase: 'none',
      textDecoration: 'none',
      weight: '400'
    },
    heading: {
      fontFamily: 'Asap',
      fontSize: '25px',
      fontWeight: 'Regular',
      letterSpacing: '0',
      lineHeight: '32px',
      paragraphSpacing: '0',
      textCase: 'none',
      textDecoration: 'none',
      weight: '400'
    },
    headingLarge: {
      fontFamily: 'Asap',
      fontSize: '35px',
      fontWeight: 'Regular',
      letterSpacing: '0',
      lineHeight: '48px',
      paragraphSpacing: '0',
      textCase: 'none',
      textDecoration: 'none',
      weight: '400'
    },
    headingSmall: {
      fontFamily: 'Asap',
      fontSize: '21px',
      fontWeight: 'Medium',
      letterSpacing: '0',
      lineHeight: '32px',
      paragraphSpacing: '0',
      textCase: 'none',
      textDecoration: 'none',
      weight: '500'
    }
  }
};

export { lightTheme };
